// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3HO6R","upload":"Small_upload__3pn9W","imageWrap":"Small_imageWrap__1vEkE","removeBtn":"Small_removeBtn__17InD"};